import type { SiteDeviceType, SiteSeverity } from "@safers/api";

export type SeverityLevel = "normal" | "warning" | "danger";

const SEVERITY_LEVEL: Record<SiteSeverity, SeverityLevel> = {
  NORMAL: "normal",
  UNCERTAIN: "warning",
  ATTENTION: "warning",
  CAUTION: "warning",
  WARNING: "warning",
  CRITICAL: "danger",
};

export function severityLevel(severity: SiteSeverity | null | undefined): SeverityLevel {
  if (!severity) return "normal";
  return SEVERITY_LEVEL[severity] ?? "normal";
}

export const SITE_DEVICE_TYPE_LABELS: Record<SiteDeviceType, string> = {
  HEAT_INDEX: "체감온도계",
  GAS_DETECTOR: "유해가스 측정기",
  SMART_BAND: "스마트 밴드",
};

// 최신순. 같은 시각이면 id 가 큰 쪽(나중에 들어온 쪽)이 앞선다.
export function byTimeDesc<T extends { id: number; timestamp: string }>(events: T[]): T[] {
  return [...events].sort((a, b) => {
    const d = Date.parse(b.timestamp) - Date.parse(a.timestamp);
    if (d !== 0 && !Number.isNaN(d)) return d;
    return b.id - a.id;
  });
}
